__turbopack_context__.v({
  "button": "_oeOKq_button",
  "button__squared": "_oeOKq_button__squared",
  "buttonaccent": "_oeOKq_buttonaccent",
  "buttonprimary": "_oeOKq_buttonprimary",
  "buttonsecondary": "_oeOKq_buttonsecondary",
  "buttonsecondary--selected": "_oeOKq_buttonsecondary--selected",
  "buttontertiary": "_oeOKq_buttontertiary",
  "disabledBtn": "_oeOKq_disabledBtn",
  "extraMargin": "_oeOKq_extraMargin",
  "fullWidth": "_oeOKq_fullWidth",
  "noMinWidth": "_oeOKq_noMinWidth",
  "selected": "_oeOKq_selected",
  "useCheckmark": "_oeOKq_useCheckmark",
});
